import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_UNUSED_FILTERS } from '../queries/unusedFiltersQuery';
import * as AssetBusinessType from 'ecosystem-marketplace-core/constants/groupTags/AssetBusinessType';
export function useUsedBusinessTypeValues() {
  const {
    loading,
    data
  } = useQuery(GET_UNUSED_FILTERS);
  return useMemo(() => {
    const assetBusinessTypes = Object.values(AssetBusinessType);
    if (loading || !data) return assetBusinessTypes;
    return Object.values(AssetBusinessType).filter(value => !data.unusedFilters.unusedIndustries.includes(value));
  }, [loading, data]);
}